"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermsFields = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _fields = require("../../fields");
var _ui = require("../../ui");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var CheckBoxDescription = (0, _styledComponents.default)(_ui.SmallMedium)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", " !important;\n  text-align: justify;\n  margin-bottom: 0;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiary;
});
var termsLinks = {
  AMLPolicy: 'https://aml-policy.com',
  refundPolicy: 'https://refund-policy.com'
};
var TermsFields = function TermsFields(_ref2) {
  var control = _ref2.control,
    termsOfUseUrl = _ref2.termsOfUseUrl,
    privacyPolicyUrl = _ref2.privacyPolicyUrl;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, {
    check: true
  }, /*#__PURE__*/_react.default.createElement(_fields.CheckBoxInputField, {
    withFeedback: false,
    control: control,
    inputProps: {
      name: 'terms'
    }
  }), /*#__PURE__*/_react.default.createElement(CheckBoxDescription, null, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "libAuth:terms1"
  }, /*#__PURE__*/_react.default.createElement(_ui.Link, {
    target: "_blank",
    href: termsOfUseUrl
  }), /*#__PURE__*/_react.default.createElement(_ui.Link, {
    target: "_blank",
    href: privacyPolicyUrl
  }), /*#__PURE__*/_react.default.createElement(_ui.Link, {
    target: "_blank",
    href: termsLinks.AMLPolicy
  }))))), /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, {
    check: true
  }, /*#__PURE__*/_react.default.createElement(_fields.CheckBoxInputField, {
    withFeedback: false,
    control: control,
    inputProps: {
      name: 'policy'
    }
  }), /*#__PURE__*/_react.default.createElement(CheckBoxDescription, null, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "libAuth:terms2"
  }, /*#__PURE__*/_react.default.createElement(_ui.Link, {
    target: "_blank",
    href: termsLinks.refundPolicy
  }))))));
};
exports.TermsFields = TermsFields;